import { render, staticRenderFns } from "./TourManagerEdit.vue?vue&type=template&id=65f7818a&"
import script from "./TourManagerEdit.vue?vue&type=script&lang=js&"
export * from "./TourManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports